<template>
    <div v-if="this.languages">
        {{ this.generateHint }}
    </div>
</template>

<script>
import rules_dictionary from "@/scripts/store/rules_dictionary";
import {mapActions, mapState} from "pinia";
import {languagesStore} from "@/scripts/store/languages.store";

export default {
    props: {
        rule: {
            required: true
        }
    },

    data() {
        return {
            isLoading: true
        }
    },

    mounted() {
        this.loadLanguages()
    },

    computed: {
        ...mapState(languagesStore, ['languages']),
        generateHint() {
            if (!this.languages) {
                return ''
            }

            if (this.rule.type === 'device') {
                const devices = rules_dictionary.devices
                return "только для устройств: " + this.rule.data.devices.map(d => devices.find(device => device.id === d).title).join(", ")
            }

            if (this.rule.type === 'day') {
                const days = rules_dictionary.days
                return "только для дней: " + this.rule.data.days.map(d => days.find(day => day.id === d).title).join(", ")
            }

            if (this.rule.type === 'time') {
                return "только в промежутке между  " + this.rule.data.from + " и " + this.rule.data.to
            }

            if (this.rule.type === 'language') {
                return "только если язык пользователя:  " + this.rule.data.languages.map(
                    el => this.languages.find(f => f.label === el).name
                )
            }

            if (this.rule.type === 'location') {
                return "ограничения по гео"
            }

            if (this.rule.type === 'scans-count') {
                if (this.rule.data.comparisonType === 'equal') {
                    return "только если это " + this.rule.data.count + "-ое сканирование (в рамках устройства)"
                }

                if (this.rule.data.comparisonType === 'less') {
                    return "только если кол-во сканирований меньше, чем " + this.rule.data.count + " на этом устройстве"
                }

                if (this.rule.data.comparisonType === 'more') {
                    return "только если кол-во сканирований больше, чем " + this.rule.data.count + " на этом устройстве"
                }
            }
        }
    },

    methods: {
        ...mapActions(languagesStore, ['loadLanguages'])
    },
}
</script>

<style scoped>

</style>
